// The phone in the top bar (Stage 4.8f.4b, mockup "Where the phone lives"): opens and minimises the docked phone, and says what it is
// doing — on a call (and for how long), ringing, on hold, or just the phone with its line's state.
import { ButtonBase, Box } from "@mui/material";
import { Phone, PhoneIncoming } from "lucide-react";
import { useTranslation } from "react-i18next";
import { usePhoneState } from "./phoneContext";
import { fmtDur, useSince } from "./phoneFormat";

export default function PhoneTopButton() {
  const { t } = useTranslation("phone");
  const p = usePhoneState();
  const calls = p?.line?.calls ?? [];
  const active = calls.find((c) => c.state === "active");
  const ringing = calls.find((c) => c.state === "ringing");
  const held = calls.find((c) => c.state === "held");
  const since = useSince(active?.answeredAt ?? null);
  if (!p?.hasPhone) return null;

  const tone = active ? { bg: "var(--success-bg)", fg: "var(--success)" } : ringing ? { bg: "var(--warning-bg)", fg: "var(--warning)" }
    : { bg: "var(--surface-card)", fg: "var(--ink-800)" };
  const text = active ? `${t("onACall")} · ${fmtDur(since)}` : ringing ? t("ringingTop") : held ? t("onHold") : t("phone");
  const lineColor = !p.available ? "var(--ink-400)" : p.line.reg === "registered" ? "var(--success)" : "var(--warning)";
  return (
    <ButtonBase onClick={() => p.setOpen(!p.open)} aria-expanded={p.open} aria-label={`${text}. ${p.open ? t("minimise") : t("openPhone")}`}
      sx={{ gap: "8px", height: 36, px: "12px", borderRadius: "var(--r-pill)", border: "1px solid var(--line-200)", background: tone.bg, color: tone.fg,
        font: "700 13px/1 var(--font-ui)", fontVariantNumeric: "tabular-nums",
        ...(ringing ? { "@media (prefers-reduced-motion: no-preference)": { animation: "phoneTopPulse 1.2s var(--ease-out) infinite" },
          "@keyframes phoneTopPulse": { "0%,100%": { boxShadow: "0 0 0 0 var(--warning-bg)" }, "50%": { boxShadow: "0 0 0 6px var(--warning-bg)" } } } : {}) }}>
      {ringing ? <PhoneIncoming size={16} aria-hidden="true" /> : <Phone size={16} aria-hidden="true" />}
      <Box component="span" sx={{ display: { xs: active || ringing ? "inline" : "none", sm: "inline" } }}>{text}</Box>
      {!active && !ringing && <Box component="span" aria-hidden="true" sx={{ width: 7, height: 7, borderRadius: "50%", background: lineColor }} />}
    </ButtonBase>
  );
}
